/**
 * @generated SignedSource<<f91107054e6d89e158c79421c3c30784>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type PreviewWidgetPushAppyIntegrationInput = {
  size?: WidgetOverviewSize | null;
  storecastId?: string | null;
};
export type WAPushAppyQuery$variables = {
  input: PreviewWidgetPushAppyIntegrationInput;
  storecastId: string;
};
export type WAPushAppyQuery$data = {
  readonly dashboard: {
    readonly previewWidgetPushAppyIntegration: {
      readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationPushAppy_widgetIntegrationPushAppy">;
    } | null;
  };
};
export type WAPushAppyQuery = {
  response: WAPushAppyQuery$data;
  variables: WAPushAppyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storecastId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storecastId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WAPushAppyQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": "Dashboard",
          "kind": "LinkedField",
          "name": "dashboard",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v2/*: any*/),
              "concreteType": "WidgetIntegrationPushAppy",
              "kind": "LinkedField",
              "name": "previewWidgetPushAppyIntegration",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetIntegrationPushAppy_widgetIntegrationPushAppy"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WAPushAppyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "WidgetIntegrationPushAppy",
            "kind": "LinkedField",
            "name": "previewWidgetPushAppyIntegration",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "overviewSize",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetIntegrationPushAppyLeaderboardItem",
                "kind": "LinkedField",
                "name": "leaderboard",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "goal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "progress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "556842606222ce3040f4c6db8022dbba",
    "id": null,
    "metadata": {},
    "name": "WAPushAppyQuery",
    "operationKind": "query",
    "text": "query WAPushAppyQuery(\n  $input: PreviewWidgetPushAppyIntegrationInput!\n  $storecastId: ID!\n) {\n  dashboard(id: $storecastId) {\n    previewWidgetPushAppyIntegration(input: $input) {\n      ...WidgetIntegrationPushAppy_widgetIntegrationPushAppy\n      id\n    }\n    id\n  }\n}\n\nfragment WidgetIntegrationPushAppy_widgetIntegrationPushAppy on WidgetIntegrationPushAppy {\n  id\n  title\n  overviewSize\n  leaderboard {\n    id\n    title\n    goal\n    progress\n    total\n  }\n}\n"
  }
};
})();

(node as any).hash = "a5b9f1884b2beb95ca68b1e823dd26d0";

export default node;
